// Port of api/fuel/app/classes/controller/api/monty/views/view/remove.php
import DB from 'offline/db'
import Constants from 'offline/constants'

function viewToArray(row) {
	var fields = row.view_fields || []
	if (typeof fields === 'string') {
		try { fields = JSON.parse(fields) } catch (e) { fields = [] }
	}
	return {
		id: parseInt(row.view_id, 10) || 0,
		default: parseInt(row.view_default, 10) || 0,
		type: parseInt(row.view_type, 10) || 0,
		context: parseInt(row.view_context, 10) || 0,
		public: parseInt(row.view_public, 10) || 0,
		name: row.view_name,
		fields: fields
	}
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var model = params.model || {}
	var viewId = parseInt(model.id, 10) || 0
	var rows = viewId ? DB.query('SELECT * FROM view WHERE user_id = ? AND view_id = ?', [userId, viewId]) : []

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (!rows.length) {
		return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
	}

	var view = viewToArray(rows[0])
	DB.run('DELETE FROM view WHERE view_id = ?', [viewId])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: view
		}
	})
}
